<template>
  <el-container direction="vertical" id="personnelCorrecting">
    <el-main>
      <el-col :span="16" :push="4">
        <el-form label-width="150px" style="text-align: left;">
          <el-card class="box-card">
            <div class="box-card-div-title userInfo"><div class="header">人员变更</div></div>
            <el-form-item class="form-item-label" label="保单号">
              <div class="rightUnit">{{accode}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="投保企业名称">
              <div class="rightUnit">{{dynamicValidateForm.companyName}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="有效期间">
              <div class="rightUnit">{{orderInfoLog.effectiveDate}}  —— {{orderInfoLog.expireDate}}</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="批改生效日期">
              <div class="block rightUnit">
                <el-date-picker
                  v-model="correctingDate"
                  type="date"
                  placeholder="请选择"
                  value-format="yyyy-MM-dd"
                  format="yyyy 年 MM 月 dd 日"
                  class="my-el-date-picker"
                  :picker-options="pickerOptions"
                  @change="correctingDateChange"
                >
                </el-date-picker>
              </div>
              <p class="warmPrompt">温馨提示：加保为所选生效日当日0时生效，减保为所选生效日当日24时生效</p>
            </el-form-item>
            <el-form-item class="form-item-label" label="原保单保障项目">
              <el-table
                :data="insureEnsureDatum"
                border
                max-height="500"
                class="my-el-table"
                style="margin-bottom: 40px">
                <el-table-column
                  align="center"
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope">
                    保障计划{{$$.changeNumToHan(scope.$index + 1)}}
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="occName"
                  label="职业类别">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="groupSize"
                  label="投保人数">
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="skuProductSpecValueList[3].specName"
                  label="意外伤害">
                </el-table-column>
                <el-table-column
                  align="center"
                  width="120"
                  prop="skuProductSpecValueList[4].specName"
                  label="意外伤害医疗">
                </el-table-column>
                <el-table-column
                  align="center"
                  width="120"
                  prop="skuProductSpecValueList[5].specName"
                  label="意外住院津贴">
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item class="form-item-label addPersonnel " label="增加人员">
              <el-button ><a style="display: inline;color: #ffffff"
                             @click="$$.download('https://pic.xiaobaibao.com/system/reportTemp/2021/6/635f0d7a736a43719ce10c2f544e0022.xls','保全清单模板')"
              >下载批量加保人员模板</a></el-button>
              <el-upload style="display: inline-block"
                         action="#"
                         :before-upload="addUploadFile"
                         :show-file-list="false"
              >
                <el-button class="header-row-col-button-failure">批量上传加保人员</el-button>
              </el-upload>
              <el-button @click="batchSetInsuranceScheme" >批量设置投保方案</el-button>
              <el-button @click="addAPersonPopup(0)" >单个新增加保人员</el-button>
              <el-button @click="emptyInsured({state: 0})" >清空</el-button>
              <el-table
                ref="addPersonnelList"
                :data="endorInsuredAddList"
                border
                style="width: 100%;margin-bottom: 15px">
                <el-table-column
                  type="selection"
                  width="50">
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="被保险人姓名"
                  width="110">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="60">
                  <template slot-scope="scope">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? '保障计划'+supportPlan(scope.row.skuId, 0) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="职业类别">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? supportPlan(scope.row.skuId, 1) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="idnumber"
                  width="170"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  width="100"
                  label="增加保费">
                  <template slot-scope="scope">
                    <div :style="{color: scope.row.insuMoney == 0 ? '#FF7052' : ''}" >
                      {{scope.row.insuMoney == 0 ? '——' : scope.row.insuMoney + '元'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="242">
                  <template slot-scope="scope">
                    <el-button @click="addAPersonPopup(1, scope)">设置投保方案</el-button>
                    <el-button @click="emptyInsured({id: scope.row.id})">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="ErrorReminder" v-if="addErrorReminder.errorReminderState">
                <div style="color: #FF7052">
                  共<span>{{addErrorReminder.countSize}}</span>人，
                  成功导入<span>{{addErrorReminder.successSize}}</span>人，
                  <span>{{addErrorReminder.errorSize}}</span>人导入失败，请重新导入，或者单个新增加保人员！
                </div>
                <div style="font-weight: bold;font-size: 1.125rem;color: #333333;margin: 10px auto">错误提醒：</div>
                <div style="color: #666666;max-height: 200px;overflow: auto;padding: 5px 10px">
                  <div v-for="(item, index) in addErrorReminder.errorReminderList">
                    <span>{{index+1}}</span>、
                    姓名：<span>{{item.name}}</span>，
                    证件号码：<span>{{item.idNumber}}</span>
                    （错误原因：<span>{{item.errorMsg}}</span>）
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="form-item-label addPersonnel " label="退保人员">
              <el-button @click="chooseList" >选择人员</el-button>
              <el-button ><a style="display: inline;color: #ffffff"
                             @click="$$.download('https://pic.xiaobaibao.com/system/reportTemp/2021/6/9d0cb6fa211c489eae3e44acdcd78f68.xls','保全清单模板')"
              >下载批量减保人员模板</a></el-button>
              <el-upload style="display: inline-block"
                         action="#"
                         :before-upload="subtractUploadFile"
                         :show-file-list="false"
              >
                <el-button class="header-row-col-button-failure">批量上传减保人员</el-button>
              </el-upload>
              <el-button @click="emptyInsured({state: 1})" >清空</el-button>
              <el-table
                :data="endorInsuredSubtractList"
                border
                style="width: 100%;margin-bottom: 15px">
                <el-table-column
                  prop="name"
                  label="被保险人姓名"
                  width="120">
                </el-table-column>
                <el-table-column
                  label="性别"
                  width="60">
                  <template slot-scope="scope">
                    {{scope.row.sex == 'O' ? '其他' : (scope.row.sex == 'F' ? '女' : '男')}}
                  </template>
                </el-table-column>
                <el-table-column
                  width="100"
                  label="保障计划">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? '保障计划'+supportPlan(scope.row.skuId, 0) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="职业类别">
                  <template slot-scope="scope">
                    <div :style="{color: $$.isValidObj(scope.row.skuId) ? '' : '#FF7052'}" >
                      {{$$.isValidObj(scope.row.skuId) ? supportPlan(scope.row.skuId, 1) : '未设置'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="idnumber"
                  width="170"
                  label="证件号码">
                </el-table-column>
                <el-table-column
                  width="110"
                  label="减少保费">
                  <template slot-scope="scope">
                    <div :style="{color: scope.row.insuMoney == 0 ? '#FF7052' : ''}" >
                      {{scope.row.insuMoney == 0 ? '——' : scope.row.insuMoney + '元'}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="110">
                  <template slot-scope="scope">
                    <el-button @click="emptyInsured({id: scope.row.id})">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="ErrorReminder" v-if="subtractErrorReminder.errorReminderState">
                <div style="color: #FF7052">
                  共<span>{{subtractErrorReminder.countSize}}</span>人，
                  成功导入<span>{{subtractErrorReminder.successSize}}</span>人，
                  <span>{{subtractErrorReminder.errorSize}}</span>人导入失败，请重新导入，或者重新选择人员！
                </div>
                <div style="font-weight: bold;font-size: 1.125rem;color: #333333;margin: 10px auto">错误提醒：</div>
                <div style="color: #666666;height: 200px;overflow: auto;padding: 5px 10px">
                  <div v-for="(item, index) in subtractErrorReminder.errorReminderList">
                    <span>{{index+1}}</span>、
                    姓名：<span>{{item.name}}</span>，
                    证件号码：<span>{{item.idNumber}}</span>
                    （错误原因：<span>{{item.errorMsg}}</span>）
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item class="form-item-label" label="加保人员数量合计">
              <div class="rightUnit">{{addHeadcount}}人</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="加保人员保费合计">
              <div class="rightUnit">{{addTotalPremium}}元</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="退保人员数量合计">
              <div class="rightUnit">{{subtractHeadcount}}人</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="退保人员保费合计">
              <div class="rightUnit">{{subtractTotalPremium == 0 ? subtractTotalPremium : '-'+subtractTotalPremium}}元</div>
            </el-form-item>
            <el-form-item class="form-item-label" label="合计保费变更">
              <div class="rightUnit">{{totalPremium}}元</div>
            </el-form-item>
            <el-form-item class="form-item-label" :label="actualPremiumsName">
              <div class="rightUnit">{{actualPremiums}}元</div>
              <p class="warmPrompt" v-if="refundWarmPrompt">温馨提示：由于产生保费退费，需要补扣佣金{{paidInPremium}}元，佣金从钱包扣除</p>
            </el-form-item>
            <el-form-item label="收款账户" class="form-item-label" v-if="totalPremium < 0">
              <el-input v-model="bankAccount"
                        placeholder="请输入收款账户(银行卡号)"
                        maxlength="19"
              ></el-input>
            </el-form-item>
          </el-card>
          <el-card class="box-card" v-if="totalPremium>0">
            <div class="box-card-div-title userInfo"><div class="header">发票信息</div></div>
            <el-form-item label="是否需要" class="form-item-label-big">
              <el-radio-group v-model="needInvoices">
                <el-radio-button class="my-button" :label="true">需要</el-radio-button>
                <el-radio-button class="my-button" :label="false">不需要</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <span v-if="needInvoices">
              <el-form-item label="发票类型" class="form-item-label-big">
              <div>
                <el-radio-group v-model="receiptType">
                  <el-radio-button class="my-button" :label="2">普通发票(电子发票)</el-radio-button>
                  <el-radio-button class="my-button" :label="1">增值税专用发票（纸质发票）</el-radio-button>
                </el-radio-group>
              </div>
              </el-form-item>
              <span v-if="receiptType === 2">
                <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                <el-form-item label="发票抬头" class="form-item-label">
                  <el-input :disabled="true" class="form-item-input my-input-left "
                            v-model="dynamicValidateForm.companyName"
                            placeholder="请输入发票抬头"
                  ></el-input>
                </el-form-item>
                <el-form-item label="纳税人识别号" class="form-item-label">
                  <el-input v-if="idType === 6" class="form-item-input my-input-left "
                            v-model="socialCreditCode" :disabled="true"
                            placeholder="请输入纳税人识别号"
                  ></el-input>
                  <el-input v-else class="form-item-input my-input-left "
                            v-model="orderMailInvoiceInfo.tIN"
                            placeholder="请输入纳税人识别号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                <el-form-item label="收件人姓名" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            v-model="orderMailInvoiceInfo.rName"
                            placeholder="请输入收件人姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人手机号" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            v-model="orderMailInvoiceInfo.rPhone"
                            placeholder="请输入收件人手机号码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="收件人邮箱" class="form-item-label">
                  <el-input class="form-item-input my-input-left "
                            v-model="orderMailInvoiceInfo.rMail"
                            placeholder="请输入收件人邮箱"
                  ></el-input>
                </el-form-item>
              </span>
              <span v-else-if="receiptType === 1">
                <el-form-item label="发票内容" class="form-item-label-big"></el-form-item>
                  <el-form-item label="发票抬头" class="form-item-label">
                    <el-input :disabled="true" class="form-item-input my-input-left "
                              v-model="dynamicValidateForm.companyName"
                              placeholder="请输入发票抬头"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="纳税人识别号" class="form-item-label">
                    <el-input v-if="idType === 6" class="form-item-input my-input-left "
                              v-model="socialCreditCode" :disabled="true"
                              placeholder="请输入纳税人识别号"
                    ></el-input>
                    <el-input v-else class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.tIN"
                              placeholder="请输入纳税人识别号"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="税务登记地址" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.tRA"
                              placeholder="请输入税务登记地址"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="税务登记电话" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.tRT"
                              placeholder="请输入税务登记电话"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="开户银行" class="form-item-label">
                    <el-select v-model="orderMailInvoiceInfo.openBank" placeholder="请选择开户银行" class="form-item-input my-input-left" style="width: 200px">
                      <el-option
                        v-for="item in bankTypeList"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="银行账户" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.bankNum"
                              placeholder="银行账户"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人信息" class="form-item-label-big"></el-form-item>
                  <el-form-item label="收件人姓名" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.rName"
                              placeholder="请输入收件人姓名"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人手机号" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.rPhone"
                              placeholder="请输入收件人手机号码"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="收件人地址" class="form-item-label">
                  <el-select @change="rProvinceChange" v-model="orderMailInvoiceInfo.rProvinceId" placeholder="请选择"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in chinaArea"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select @change="rCityChange" v-model="orderMailInvoiceInfo.rCityId" placeholder="请选择"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in orderMailInvoiceInfo.rCityList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="orderMailInvoiceInfo.rAreaId" placeholder="请选择"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in orderMailInvoiceInfo.rAreaList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  </el-form-item>
                  <el-form-item label="具体地址" class="form-item-label">
                    <el-input class="form-item-input my-input-left "
                              v-model="orderMailInvoiceInfo.rAddress"
                              placeholder="请输入具体地址"
                    ></el-input>
                  </el-form-item>
              </span>
            </span>
          </el-card>
          <div class="submitOrder">
            <el-button @click="submitOrder" class="header-button-order-add">提交订单</el-button>
          </div>
        </el-form>
      </el-col>
      <el-col :span="16" :push="4" @click.native="closeAddAPersonPopup($event)" class="addAPersonPopup" v-if="addDialogVisible"  >
        <el-form label-width="155px" style="text-align: left;">
          <el-card class="box-card">
            <div class="box-card-div-title userInfo" style="width: 192px"><div class="header">{{addDialogVisibleTitle}}</div></div>
            <div v-if="addDialogPopupState == 0">
              <el-form-item label="被保人基本信息" class="form-item-label-big"></el-form-item>
              <el-form-item label="被保人姓名" class="form-item-label">
                <el-input class="form-item-input addAPerson-Right-input"
                          v-model="addBeInsureData.addBeInsureName"
                          placeholder="请输入被保险人员姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="证件类型" class="form-item-label">
                <el-select v-model="addBeInsureData.addBeInsureIdType" placeholder="请选择"
                           class="form-item-input addAPerson-Right-input" >
                  <el-option label="身份证" :value=1></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="证件号码" class="form-item-label">
                <el-input class="form-item-input addAPerson-Right-input"
                          v-model="addBeInsureData.addBeInsureIdCard"
                          placeholder="请输入证件号码"
                          @change="addBeInsureIdCardChange"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别" class="form-item-label-add">
                <el-select v-model="addBeInsureData.addBeSex" placeholder="请选择"
                           class="form-item-input addAPerson-Right-input">
                  <el-option label="男性" value="M"></el-option>
                  <el-option label="女性" value="F"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="addDialogPopupState == 1">
              <el-form-item label="已选被保人名单" class="form-item-label-big"></el-form-item>
              <el-form-item label="被保人姓名" class="form-item-label addUserList">
                <el-tag
                  v-for="tag in batchSetUserList"
                  :key="tag.id"
                  closable
                  @close="deleteBatchSetUser(tag)">
                  {{tag.name}}
                </el-tag>
              </el-form-item>
              <el-form-item label="合计人数" class="form-item-label">
                <el-input class="form-item-input addAPerson-Right-input"
                          v-model="batchSetTotalNumber"
                ></el-input>
              </el-form-item>
            </div>
            <el-form-item label="保障计划信息" class="form-item-label-big"></el-form-item>
            <el-form-item label="保障计划" class="form-item-label">
              <el-select v-model="addBeInsureData.bePlan" placeholder="请选择"
                         class="form-item-input" style="width: 192px" @change="bePlanChange">
                <el-option
                  v-for="(item,index) in insureEnsureDatum"
                  :key="index+1"
                  :label="'保障计划' + $$.changeNumToHan(index + 1)"
                  :value="index">
                </el-option>
              </el-select>
              <!--<el-button @click="addNewPlan" >添加新计划</el-button>-->
            </el-form-item>
            <div>
              <!--保障计划详情 待写-->
            </div>
            <div v-if="addNewPlanState">
              <el-form-item class="form-item-label" label="保单号">
                <div class="rightUnit" style="width: 144px;margin: 0 5px 5px 10px;text-align: center">{{'保障计划' + $$.changeNumToHan(1) }}</div>
                <el-button @click="deletePlan" >删除计划</el-button>
              </el-form-item>
              <div v-for="(card, index) in dynamicValidateForm.cards"
                   :key="card.key">
                <div :id="card.key">
                  <el-form-item
                    class="form-item-label"
                    :label="'职业类别'"
                    :rules="[{
                              required: true,
                              message: '请选择职业',
                              trigger: 'blur'
                            }]"
                  >
                    <el-select @change="occOneChange(index)" v-model="card.occOneId" placeholder="请选择"
                               class="form-item-input my-input">
                      <el-option
                        v-for="item  in dynamicValidateForm.occOneList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <el-select @change="occTwoChange(index)" v-model="card.occTwoId" placeholder="请选择"
                               class="form-item-input my-input">
                      <el-option
                        v-for="item in card.occTwoList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <el-select @change="occThreeChange(index)" v-model="card.occThreeId" placeholder="请选择"
                               class="form-item-input my-input">
                      <el-option
                        v-for="item in card.occThreeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                      </el-option>
                    </el-select>
                    <div class="form-item-input" style="min-width: 144px;width: max-content;padding: 0 10px">职业代码: {{card.realityOccCode}}</div>
                  </el-form-item>
                  <el-form-item
                    class="form-item-label"
                    :label="'意外伤害'"
                    :rules="[
                              { required: true, message: '请选择意外伤害', trigger: 'blur' }
                            ]"
                  >
                    <el-select v-model="card.hurtValue" placeholder="请选择" class="form-item-input my-input"
                               @change="hurtChange(index)">
                      <el-option
                        v-for="item in card.hurtList"
                        :key="item.id"
                        :label="item.specName"
                        :value="item.specName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="form-item-label"
                    :label="'意外伤害医疗'"
                    :rules="[
                              { required: true, message: '请选择意外伤害医疗', trigger: 'blur' }
                            ]"
                  >
                    <el-select v-model="card.medicalValue" placeholder="请选择" class="form-item-input my-input"
                               @change="medicalChange(index)">
                      <el-option
                        v-for="item in card.medicalList"
                        :key="item.id"
                        :label="item.specName"
                        :value="item.specName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    class="form-item-label"
                    :label="'意外住院津贴'"
                    :rules="[
                              { required: true, message: '请选择意外住院津贴', trigger: 'blur' }
                            ]"
                  >
                    <el-select v-model="card.allowanceValue" placeholder="请选择" class="form-item-input my-input"
                               @change="allowanceChange(index)">
                      <el-option
                        v-for="item in card.allowanceList"
                        :key="item.id"
                        :label="item.specName"
                        :value="item.specName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="increasePremium">
              <span>{{'增加保费：' + increasePremium + '元'}}</span>
            </div>
            <div class="addAPerson-button">
              <el-button class="addAPersonPopup-cancel" >取消</el-button>
              <el-button @click="addConfirm" >确定</el-button>
            </div>
          </el-card>
        </el-form>
      </el-col>
      <el-col :span="16" :push="4" @click.native="closeChoosePopup($event)" class="chooseListPopup" v-if="chooseListVisible"  >
        <el-form label-width="155px" style="text-align: left;">
          <el-card>
            <div class="title space-between">
              <span>选择退保人员</span>
              <span class="chooseListPopup-close" style="font-size: 28px;font-weight: bold;color: #333333">×</span>
            </div>
            <div class="query">
              <span style="padding-right: 40px">姓名:</span>
              <input type="text" v-model="selectUserName" @input="queryUserName">
              <button @click="queryUserName" >查询</button>
            </div>
            <el-table
              :data="insuredUserInfoNewList"
              style="width: 100%;">
              <el-table-column
                prop="name"
                label="被保险人姓名">
              </el-table-column>
              <el-table-column
                width="100"
                label="保障计划">
                <template slot-scope="scope">
                  <div>{{'保障计划'+supportPlan(scope.row.skuId, 0)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="cardType"
                label="证件类型">
              </el-table-column>
              <el-table-column
                prop="cardNum"
                label="证件号码">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="chooseAdd(scope.row)" size="mini" style="background: #FF7052;border-radius: 8px;color: #ffffff;">添加</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-form>
      </el-col>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">
  export default {
    name: "personnelCorrecting",
    data() {
      return {
        accode: '',                       // 保单号
        endorInsuredAddList: [],          // 加载 - 保全增保被保人数据（）
        endorInsuredSubtractList: [],     // 加载 - 保全减保被保人数据（）
        orderId: null,                    // 加载 - 订单ID
        endorOrderId: null,               // 加载 - 保全ID
        orderEndorInfoLogEntity: null,    // 加载 - 保全实体
        insureEnsureDatum: [],            // 加载 - 保障计划
        insuredUserInfoList: [],          // 加载 - 原保单被保人数据
        insuredUserInfoNewList: [],       // 加载 - 新保单被保人数据
        orderInfoLog: {},                 // 订单详情
        planId: null,
        productId: null,
        moneyMap: {},
        dynamicValidateForm: {
          cards: [{
            groupSize: '',
            occId: '',
            realityOccCode: '',
            //-- 职业参数
            occOneId: '',
            occTwoList: [],
            occTwoId: '',
            occThreeList: [],
            occThreeId: '',
            occOneName: '',
            occTwoName: '',
            occThreeName: '',
            //规格值列表数据
            hurtList: [],
            medicalList: [],
            allowanceList: [],
            //规格选项值
            hurtValue: '',
            medicalValue: '',
            allowanceValue: '',
            //职业id
            occupationId: 0,
            //职业类别
            azcnCode: 0,
            //取值获取规格值下拉选项
            pid: 0,
            topLevelId: 0,
            skuInfo: {},
          }],
          companyName: '',
          guaranteePeriod: "12个月",
          insuranceAge: "18-65周岁",
          occupationType: "1-5类",
          occOneList: [],
          //-- sku参数
          skuList: [],
          skuSpecList: [],
          skuRelationAddList: [],
          occupationList: [],
        },
        orderMailInvoiceInfo: {
          tIN: '', // 纳税人识别号
          rName: '', // 收件人姓名
          rPhone: '', // 收件人手机号
          rMail: '', // 收件人邮箱
          tRA: '', // 税务登记地址
          tRT: '', // 税务登记电话
          openBank: '', // 开户银行
          bankNum: '', // 银行账户
          rCityId: '', // 	城市ID
          rProvinceId: '', // 	省份ID
          rAreaId: '', // 	地区ID
          rAddress: '', // 收件人具体地址
          rCityList: [],
          rAreaList: []
        },
        orderEndorToken: null,        // 保全订单token(加密)
        correctingDate: '',           // 批改生效时间
        addPersonnelList: [],         // 添加人员集合
        needInvoices: false,          // 是否需要 - 发票信息
        receiptType: 2,               // 发票类型
        addNewPlanState: false,       // 添加新计划
        addDialogVisible: false,      // 增加被保人弹窗
        addDialogVisibleTitle: '',    // 增加被保人弹窗 - 标题
        addDialogPopupState: 0,       // 增加被保人弹窗状态 - 0：增/编辑、1: 批量编辑
        batchSetTotalNumber: "0人",   // 批量修改投保方案 - 人员总数
        batchSetUserList: [],         // 批量修改投保方案 - 人员列表
        addDialogVisibleState: 0,     // 被保人增减状态（0：增/编辑、1：减）
        chooseListVisible: false,     // 选择退保人员弹窗
        selectUserName: '',           // 查询退保人员姓名
        addBeInsureData: {            //-- 单个被保人
          id: null,                   // 被保人id
          addBeInsureName: '',        // 被保人姓名
          addBeSex: '',               // 被保人性别
          addBeInsureIdCard: '',      // 被保人证件号
          addBeInsureIdType: '',      // 被保人证件类型
          bePlan: '',                 // 被保人对应计划
          skuId : null,               // 被保人skuId
          occupationId : null,        // 被保人职业Id
          occupationName: null,       // 被保人职业名称
        },
        increasePremium: 0,           // 增加保费
        addHeadcount: 0,              // 加保人员数量合计
        addTotalPremium: 0,           // 加保人员保费合计
        subtractHeadcount: 0,         // 退保人员数量合计
        subtractTotalPremium: 0,      // 退保人员保费合计
        totalPremium: 0,              // 合计保费变更
        actualPremiums: 0,            // 实际支付/实际退费（保费）
        actualPremiumsName: '实际支付/实际退费',  // 实际支付/实际退费（名字）
        refundWarmPrompt: false,      // 退款的温馨提示
        paidInPremium: 0,             // 退款的温馨提示 - 佣金
        bankAccount: '',              // 退款收款账户
        bankTypeList: [],             // 开户银行类型列表
        chinaArea: this.chinaLifeAccidentDistrict.chinaAreaList(),
        idType: '',
        // -- 被保人列表
        beInsureTableData: [],
        cityId: '', // 	城市ID
        provinceId: '', // 	省份ID
        areaId: '', // 	地区ID
        cityName: '', // 	城市名称
        provinceName: '', // 	省份名称
        areaName: '', // 地区名称
        socialCreditCode: '', // 证件号码
        address: '', // 联系人具体地址
        specificAddress: '', // 公司具体地址
        mobile: '',// 联系人手机号
        legalPerson: '', // 联系人
        workEmail: '', // 联系人邮箱
        pickerOptions: {
          disabledDate(time) {
            let _now = Date.now(),
              three = 0 * 24 * 60 * 60 * 1000,
              threeDays = _now + three;
            return time.getTime() < threeDays;
            //大于当前的禁止，小于7天前的禁止
          }
        },
        addErrorReminder: {
          errorReminderState: false,
          errorReminderList: [],
          countSize: 0,
          errorSize: 0,
          successSize: 0,
        },
        subtractErrorReminder: {
          errorReminderState: false,
          errorReminderList: [],
          countSize: 0,
          errorSize: 0,
          successSize: 0,
        },
      }
    },
    methods: {
      //-- 加载保全详情
      correctingInfo() {
        this.axios.post('/management/orderEndorInfoLog/orderEndorInfoLog_preservingData', {
          orderEndorToken: this.orderEndorToken,
          changeEffectiveDate: this.$$.isValidObj(this.correctingDate) ? this.$$.dateFormat(this.correctingDate) : null
        }).then((response) => {
          if (response.data.success){
            const data = response.data.datas,
              {companyName, endorInsuredUserInfoList , insureEnsureDatum, insuredUserInfoList, orderEndorInfoLogEntity, orderInfoLog, orderMailInvoiceInfo, planId, productId, moneyMap, bankAccount} = data,
              {addInsureMoney, changingPremium, paidInPremium, reduceInsureMoney} = moneyMap;
            this.dynamicValidateForm.companyName = companyName;
            this.orderEndorInfoLogEntity = orderEndorInfoLogEntity;
            this.insureEnsureDatum = insureEnsureDatum;
            this.insuredUserInfoList = insuredUserInfoList;
            this.orderInfoLog = orderInfoLog;
            this.planId = planId;
            this.productId = productId;
            this.moneyMap = moneyMap;

            if (this.$$.isValidObj(bankAccount)) this.bankAccount = bankAccount;

            //-- 保全订单状态必须为8：初始化、0：待确认、才能修改
            if (!(orderEndorInfoLogEntity.endorStatus == 0 || orderEndorInfoLogEntity.endorStatus == 8)){
              this.$confirm('当前订单状态不可编辑~', '温馨提示：', {
                showClose: false,
                closeOnClickModal: false,
                center: true,
                showCancelButton: false,
                confirmButtonText: '确认',
              }).then(() => {
                this.$router.push({name: 'personnelManagement', query:{insuranceIsGroup: "4"}});
              });
            }

            if (this.addDialogVisibleState == 0) this.insuredUserInfoNewList = insuredUserInfoList;

            if (this.$$.isValidObj(orderMailInvoiceInfo)) {
              this.needInvoices = true;
              const {rName, rPhone, rMail, remark, rAddress, rProvinceId, rCityId, rAreaId, receiptType} = orderMailInvoiceInfo,
                {tIN, tRT, tRA, bankNum, openBank} = JSON.parse(remark);

              let params = {rName, rPhone, rMail, rAddress};

              if (this.$$.isValidObj(tRT) && this.$$.isValidObj(tRA) && this.$$.isValidObj(bankNum) && this.$$.isValidObj(openBank)) {
                params = {...params, ...{tRT, tRA, bankNum, openBank, rProvinceId: rProvinceId.toString(), rCityId: rCityId.toString(), rAreaId: rAreaId.toString()}};
              }
              if (this.$$.isValidObj(tIN)) params.tIN = tIN;
              if (this.$$.isValidObj(receiptType)) this.receiptType = receiptType;

              this.orderMailInvoiceInfo = {
                ...this.orderMailInvoiceInfo,
                ...params,
              };

              if (this.$$.isValidObj(rProvinceId)){
                this.chinaArea.forEach(item => {
                  item.value === rProvinceId.toString() ? this.orderMailInvoiceInfo.rCityList = item.children : [];
                });
                this.orderMailInvoiceInfo.rCityList.forEach(item => {
                  item.value === rCityId.toString() ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
                });
              }
            }

            if (this.$$.isValidObj(orderEndorInfoLogEntity.effectiveDate)) {
              this.correctingDate = new Date(orderEndorInfoLogEntity.effectiveDate);
            } else if ( !this.$$.isValidObj(this.correctingDate) ){
              //-- 批改生效日期 - 隔天生效
              let myDate = new Date();
              myDate.setDate(myDate.getDate() + 1);
              this.correctingDate = myDate;
              this.correctingInfo();
            }

            this.orderId = orderEndorInfoLogEntity.orderId;
            this.endorOrderId = orderEndorInfoLogEntity.id;

            this.orderInfoLog.effectiveDate = this.orderInfoLog.effectiveDate.substring(0,10);
            this.orderInfoLog.expireDate = this.orderInfoLog.expireDate.substring(0,10);

            this.endorInsuredAddList = [];
            this.endorInsuredSubtractList = [];
            for (let i in endorInsuredUserInfoList){
              const {type} = endorInsuredUserInfoList[i];
              type == 0 ? this.endorInsuredAddList.push(endorInsuredUserInfoList[i]) : this.endorInsuredSubtractList.push(endorInsuredUserInfoList[i]);
            }

            this.addHeadcount = this.endorInsuredAddList.length;
            if (this.$$.isValidObj(addInsureMoney)) this.addTotalPremium = addInsureMoney;
            this.subtractHeadcount = this.endorInsuredSubtractList.length;
            if (this.$$.isValidObj(reduceInsureMoney)) this.subtractTotalPremium = reduceInsureMoney;
            if (this.$$.isValidObj(changingPremium)) {
              this.totalPremium = changingPremium;
              this.actualPremiumsName = changingPremium.toString().indexOf('-') >= 0 ? '实际退费' : '实际支付';
              this.actualPremiums = changingPremium.toString().replace('-', '');
              this.refundWarmPrompt = Number(changingPremium) < 0 ? true : false;
            }
            if (this.$$.isValidObj(paidInPremium)) this.paidInPremium = paidInPremium;
          }
        });
      },
      //-- 获取 保障计划
      supportPlan(id, type = 0) {
        for (let i in this.insureEnsureDatum){
          const {skuId, skuProductSpecValueList} = this.insureEnsureDatum[i];
          if (skuId == id){
            switch (type) {
              case 0:{
                return this.$$.changeNumToHan(parseInt(i) + 1);
              }
              case 1:{
                for (let j in skuProductSpecValueList){
                  const {name, specName} = skuProductSpecValueList[j];
                  if (name == '选择职业') return specName;
                }
                break;
              }
            }
          }
        }
      },
      //-- 获取开户银行类型列表
      bankTypeLists() {
        this.axios.post('/member/banktype/getBankTypeList', {}).then((response) => {
          let {success, datas, msg} = response.data;
          if (success) {
            let list = [];
            for (let i in datas){
              list.push({
                "label": datas[i].fullName,
              });
            }
            this.bankTypeList = list;
          }else{
            this.$message.info(msg);
          }
        });
      },
      //-- 修改批改生效日期 - 重新获取页面数据
      correctingDateChange() {
        if (this.$$.isValidObj(this.correctingDate)) {
          this.correctingDate = new Date(this.correctingDate);
          this.correctingInfo();
        }
      },
      //-- 省份改变事件
      rProvinceChange() {
        this.$forceUpdate();
        this.chinaArea.forEach(item => {
          item.value === this.orderMailInvoiceInfo.rProvinceId ? this.orderMailInvoiceInfo.rCityList = item.children : [];
        });
        this.orderMailInvoiceInfo.rCityId = '';
        this.orderMailInvoiceInfo.rAreaId = '';
      },
      //-- 城市改变事件
      rCityChange() {
        this.$forceUpdate();
        this.orderMailInvoiceInfo.rCityList.forEach(item => {
          item.value === this.orderMailInvoiceInfo.rCityId ? this.orderMailInvoiceInfo.rAreaList = item.children : [];
        });
        this.orderMailInvoiceInfo.rAreaId = '';
      },
      //-- 当选择第一个职业
      occOneChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.occOneList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occOneId ? this.dynamicValidateForm.cards[index].occTwoList = item.children : [];
          item.id === this.dynamicValidateForm.cards[index].occOneId ? this.dynamicValidateForm.cards[index].occOneName = item.name : '';
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].occTwoId = '';
        this.dynamicValidateForm.cards[index].occThreeId = '';
        this.dynamicValidateForm.cards[index].occThreeList = [];
        this.dynamicValidateForm.cards[index].realityOccCode = '';
        this.dynamicValidateForm.cards[index].azcnCode = '';
        this.dynamicValidateForm.cards[index].occThreeName = '';
        this.dynamicValidateForm.cards[index].occTwoName = '';
        this.dynamicValidateForm.cards[index].occId = '';
        this.dynamicValidateForm.cards[index].hurtList = [];
        this.dynamicValidateForm.cards[index].medicalList = [];
        this.dynamicValidateForm.cards[index].allowanceList = [];
        this.dynamicValidateForm.cards[index].hurtValue = '';
        this.dynamicValidateForm.cards[index].medicalValue = '';
        this.dynamicValidateForm.cards[index].allowanceValue = '';
      },
      //-- 当选择第二个职业
      occTwoChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.cards[index].occTwoList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occTwoId ? this.dynamicValidateForm.cards[index].occThreeList = item.children : [];
          item.id === this.dynamicValidateForm.cards[index].occTwoId ? this.dynamicValidateForm.cards[index].occTwoName = item.name : '';
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].occThreeId = '';
        this.dynamicValidateForm.cards[index].realityOccCode = '';
        this.dynamicValidateForm.cards[index].azcnCode = '';
        this.dynamicValidateForm.cards[index].occThreeName = '';
        this.dynamicValidateForm.cards[index].occId = '';
        this.dynamicValidateForm.cards[index].hurtList = [];
        this.dynamicValidateForm.cards[index].medicalList = [];
        this.dynamicValidateForm.cards[index].allowanceList = [];
        this.dynamicValidateForm.cards[index].hurtValue = '';
        this.dynamicValidateForm.cards[index].medicalValue = '';
        this.dynamicValidateForm.cards[index].allowanceValue = '';
      },
      //-- 当选择第三个职业
      occThreeChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.cards[index].occupationId = 0;
        this.dynamicValidateForm.cards[index].occThreeList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occId = item.id : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].azcnCode = item.azcnCode : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occThreeName = item.name : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].realityOccCode = item.realityOccCode : '';
        });
        this.dynamicValidateForm.occupationList.forEach(item => {
          if (this.dynamicValidateForm.cards[index].occupationId == 0) this.dynamicValidateForm.cards[index].occupationId = item.specValue == this.dynamicValidateForm.cards[index].azcnCode ? item.id : 0;
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].hurtList = [];
        this.dynamicValidateForm.cards[index].medicalList = [];
        this.dynamicValidateForm.cards[index].allowanceList = [];
        this.dynamicValidateForm.cards[index].hurtValue = '';
        this.dynamicValidateForm.cards[index].medicalValue = '';
        this.dynamicValidateForm.cards[index].allowanceValue = '';
        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.id == this.dynamicValidateForm.cards[index].occupationId) {
            this.dynamicValidateForm.cards[index].pid = item.id;
            this.dynamicValidateForm.cards[index].topLevelId = item.pid;
            return;
          }
        });
        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.pid == this.dynamicValidateForm.cards[index].pid && item.topLevelId == this.dynamicValidateForm.cards[index].topLevelId) {
            let json = {};
            json['id'] = item.id;
            json['specName'] = item.name;
            json['topLevelId'] = item.pid;
            this.dynamicValidateForm.cards[index].hurtList.push(json);
            return;
          }
        });
      },
      //-- 批量设置投保方案
      batchSetInsuranceScheme() {
        let selectionList = this.$refs.addPersonnelList.selection;
        if (selectionList.length > 0){
          this.addDialogVisible = true;
          this.addDialogPopupState = 1;
          this.addDialogVisibleTitle = '批量修改投保方案';
          this.batchSetUserList = [];

          for (let i in selectionList){
            const {id, name} = selectionList[i];
            this.batchSetUserList.push({name, id});
          }
          this.batchSetTotalNumber = this.batchSetUserList.length + "人";
        }else {
          this.$message.warning('请选择列表中需要批改的人员~');
        }
      },
      //-- 批量设置投保方案 - 删除列表人员
      deleteBatchSetUser(tag) {
        this.batchSetUserList.splice(this.batchSetUserList.indexOf(tag), 1);
        this.batchSetTotalNumber = this.batchSetUserList.length + "人";

        console.log(this.batchSetUserList.length);
        if (this.batchSetUserList.length <= 0){
          this.popupInitialize();
        }

        if (this.$$.isValidObj(this.addBeInsureData.bePlan)){
          const {skuId} = this.insureEnsureDatum[this.addBeInsureData.bePlan];
          let money = this.moneyMap[skuId];
          this.increasePremium = this.addDialogPopupState == 0 ? money : this.$$.mul(money, this.batchSetUserList.length);
        }
      },
      //-- 单个 - 新增/编辑 - 加保人员弹窗
      addAPersonPopup(state, scope) {   //state 状态（0：新增、1：设置）
        this.addDialogVisible = true;
        this.addDialogVisibleState = 0;
        this.addDialogPopupState = 0;
        this.addDialogVisibleTitle = state == 0 ? '单个新增加保人员' : '单个添加投保方案';
        this.addBeInsureData.id = null;
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.addBeInsureData.bePlan = '';
        this.addBeInsureData.skuId = null;
        this.addBeInsureData.occupationId = null;
        this.addBeInsureData.occupationName = null;
        this.increasePremium = 0;
        if (state == 1 && this.$$.isValidObj(scope)){
          console.log(scope.row);
          const {name, sex, idtype, idnumber, id, skuId, insuMoney, occupationId, occupationName} = scope.row;
          this.addBeInsureData.id = id;
          this.addBeInsureData.skuId = skuId;
          this.addBeInsureData.addBeInsureName = name;
          this.addBeInsureData.addBeSex = sex;
          this.addBeInsureData.addBeInsureIdCard = idnumber;
          this.addBeInsureData.addBeInsureIdType = idtype;
          this.addBeInsureData.occupationId = occupationId;
          this.addBeInsureData.occupationName = occupationName;
          this.increasePremium = insuMoney;

          for (let i in this.insureEnsureDatum){
            if (skuId == this.insureEnsureDatum[i].skuId){
              this.addBeInsureData.bePlan = parseInt(i);
            }
          }
        }
      },
      //-- 添加新计划
      addNewPlan() {
        this.addNewPlanState = true;
      },
      //-- 删除 新计划
      deletePlan() {
        this.addNewPlanState = false;
      },
      //-- 关闭弹窗
      closeAddAPersonPopup(event) {
        let el = event.target;
        if (el.className.toString().indexOf('addAPersonPopup') >= 0){
          this.popupInitialize();
        }
      },
      //-- 新增弹窗列表 - 初始化
      popupInitialize() {
        this.addBeInsureData.id = null;
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.addBeInsureData.bePlan = '';
        this.addBeInsureData.skuId = null;
        this.addBeInsureData.occupationId = null;
        this.addBeInsureData.occupationName = null;
        this.addDialogVisible = false;
        this.addDialogPopupState = 0;
        this.increasePremium = 0;
        this.insuredUserInfoNewList = this.insuredUserInfoList;
      },
      //-- 加保人员 (无id/type=0：新增、有id：设置、无id/type=1：减员)
      addConfirm() {
        if (!this.verifyPopoverContents()) return;

        const that = this,
          {skuId, occupationId, occupationName} = that.addBeInsureData;

        switch (that.addDialogPopupState) {
          case 0:{
            that.addAPersonConfirm();
            break;
          }
          case 1:{
            batchConfirm();
            break;
          }
        }

        //-- 批量设置投保方案
        function batchConfirm() {
          let params = [];

          for (let i in that.batchSetUserList){
            params.push({
              "id": that.batchSetUserList[i].id,
              skuId,
              occupationId,
              occupationName
            });
          }
          that.axios.post('/management/endorInsuredUserInfo/batchUpdateToSku', params).then((response) => {
            let data = response.data;
            if (data.success) {
              that.correctingInfo();
              that.popupInitialize();

              that.$message({message: '设置成功~', type: "success"});
            } else {
              that.$message.error(data.msg);
            }
          });
        }
      },
      //-- 单个被保人（新增/编辑）
      addAPersonConfirm() {
        const that = this,
          {id, addBeInsureName, addBeSex, addBeInsureIdCard, addBeInsureIdType, skuId, occupationId, occupationName} = that.addBeInsureData;

        console.log(that.addBeInsureData);
        that.axios.post('/management/endorInsuredUserInfo/insertEndorUser', {
            "id": id,                 //-- 设置投保方案时需传id;
            "orderId" : that.orderId,
            "endorOrderId" : that.endorOrderId,
            "type" : that.addDialogVisibleState,  // -- 0-增员、1-减员;
            "name" : addBeInsureName,
            "idtype" : addBeInsureIdType,         // -- 证件类型 1 - 身份证
            "idnumber" : addBeInsureIdCard,
            "sex" : addBeSex,                     // -- M-男;F-女;O-其他
            "skuId" : skuId,
            "occupationId" : occupationId,
            "occupationName" : occupationName
          }
        ).then((response) => {
          let data = response.data;
          if (data.success) {
            that.correctingInfo();
            if (this.addDialogVisibleState == 0) that.popupInitialize();

            that.$message({message: that.$$.isValidObj(id) ? '设置成功~' : '新增成功~', type: "success"});
          } else {
            that.$message.error(data.msg);
          }
        });
      },
      //-- 身份证转换 - 性别
      addBeInsureIdCardChange() {
        let card = this.addBeInsureData.addBeInsureIdCard;
        if (card.length >= 18 && this.$$.constant.beInsureIdTypeOneReg.test(card) === true){
          let cardState = parseInt(card.substr(16,1))%2==1;
          this.addBeInsureData.addBeSex = cardState ? "M" : "F";
        }
      },
      //-- 选择 保障计划
      bePlanChange() {
        const {skuId, occId, occName} = this.insureEnsureDatum[this.addBeInsureData.bePlan];
        this.addBeInsureData.skuId = skuId;
        this.addBeInsureData.occupationId = occId;
        this.addBeInsureData.occupationName = occName;

        let money = this.moneyMap[skuId];
        this.increasePremium = this.addDialogPopupState == 0 ? money : this.$$.mul(money, this.batchSetUserList.length);
        console.log(this.increasePremium)
      },
      //-- 清空 - 全部加保/减保人员
      emptyInsured({state, id}) {
        let that = this, idList = [], message = '';

        if (that.$$.isValidObj(id)){
          idList.push(id);
        }else {
          let list = state == 0 ? that.endorInsuredAddList : that.endorInsuredSubtractList;
          for (let i in list){
            const {id, type} = list[i];

            if (type == state) idList.push(id);
          }
          if (idList.length <= 0){
            this.$message.warning(state == 0 ? "加保人员列表已清空!" : "减保人员列表已清空!");
            return;
          }
        }

        that.$$.confirm({
          message: that.$$.isValidObj(id) ? '确定删除？' : (state == 0 ? "确定清空当前全部加保人员？" : "确定清空当前全部减保人员？"),
          onOk: function () {
            that.axios.post('/management/endorInsuredUserInfo/handlerEndorInsuredUser?id='+idList.join(',')).then((response) => {
              let data = response.data;
              if (data.success) {
                that.correctingInfo();

                that.$message.success(that.$$.isValidObj(id) ? '删除成功~' : (state == 0 ? "加保人员列表已清空~" : "减保人员列表已清空~"));
              } else {
                that.$message.error(data.msg);
              }
            });
          }
        });
      },
      //-- 校验增员 - 内容验证
      verifyPopoverContents() {
        const {addBeInsureName, addBeSex, addBeInsureIdCard, addBeInsureIdType, bePlan} = this.addBeInsureData;

        if (this.addDialogPopupState == 0){
          if (!this.$$.isValidObj(addBeInsureName)) {
            this.$message.error("被保人姓名不能为空!");
            return false;
          }
          if (!this.$$.isValidObj(addBeInsureIdType)) {
            this.$message.error("请选择被保人证件类型!");
            return false;
          }
          if (!this.$$.isValidObj(addBeInsureIdCard)) {
            this.$message.error("被保人证件号码不能为空!");
            return false;
          }
          if (addBeInsureIdType === 1 && this.$$.constant.beInsureIdTypeOneReg.test(addBeInsureIdCard) === false) {
            this.$message.error("身份证格式不正确!");
            return false;
          }
          /*if (this.$$.getAge(addBeBirthday.replaceAll('-', '')) < 18 || this.$$.getAge(addBeBirthday.replaceAll('-', '')) > 65) {
            this.$message.error("投保年龄必须大于18岁小于65岁!");
            return false;
          }*/
          if (!this.$$.isValidObj(addBeSex)) {
            this.$message.error("请选择被保人性别!");
            return false;
          }
        }

        if (!this.$$.isValidObj(bePlan)) {
          this.$message.error("被保人保障计划不能为空!");
          return false;
        }
        return true;
      },
      // -- 新增被保人提交
      submitAddDialogVisible() {
        if (!this.verifyPopoverContents()) return;

        try {
          console.log(this.beInsureTableData);
          this.beInsureTableData.forEach(data => {
            if (this.addBeInsureData.addBeInsureIdCard === data.beInsureIdCard) {
              throw new Error("被保人证件号码:" + data.beInsureIdCard + "已存在!");
            }
          });
        } catch (e) {
          this.$message.error(e.message);
          return;
        }
        let map = {};
        map.beInsureName = this.addBeInsureData.addBeInsureName;
        map.beSex = this.addBeInsureData.addBeSex;
        map.bePlan = this.addBeInsureData.bePlan;
        map.beInsureIdCard = this.addBeInsureData.addBeInsureIdCard;
        map.beInsureIdType = this.addBeInsureData.addBeInsureIdType;
        this.beInsureTableData.push(map);
        this.addBeInsureData.id = null;
        this.addBeInsureData.addBeInsureName = '';
        this.addBeInsureData.addBeSex = '';
        this.addBeInsureData.addBeInsureIdCard = '';
        this.addBeInsureData.addBeInsureIdType = '';
        this.addBeInsureData.bePlan = '';
        this.addDialogVisible = false;
      },
      //-- 批增 - 文件上传
      addUploadFile(file) {
        return this.uploadFileExcel(file, 0);
      },
      //-- 批减 - 文件上传
      subtractUploadFile(file) {
        return this.uploadFileExcel(file, 1);
      },
      // -- 上传被保人列表Excel文件
      uploadFileExcel(file, type) {
        let that = this;

        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          file.type !== 'application/vnd.ms-excel'
        ) {
          this.$message.error('只能上传xlsx文件');
          return false;
        }
        const formData = new window.FormData();
        formData.append('file', file);
        formData.append('formType', '40');
        formData.append('formId', this.endorOrderId);
        let loadingInstance = this.Loading.service({fullscreen: true});
        this.axios.post('/upload/attachment/upload',
          formData
        ).then((response) => {
          let data = response.data;
          if (data.success) {
            const {errorList, countSize, errorSize, successSize} = data.datas.ExcelData[0];
            if (this.$$.isValidObj(errorSize)){
              this.$message.success('批量上传成功~');
              if (errorSize > 0){
                switch (type) {
                  case 0:{
                    that.addErrorReminder = {
                      errorReminderState: true,
                      errorReminderList: errorList,
                      countSize,
                      errorSize,
                      successSize,
                    };
                    break;
                  }
                  case 1:{
                    that.subtractErrorReminder = {
                      errorReminderState: true,
                      errorReminderList: errorList,
                      countSize,
                      errorSize,
                      successSize,
                    };
                    break;
                  }
                }
              }
            }else {
              this.$message.warning('批量上传失败，请确认上传模板是否正确!');
            }


            this.correctingInfo();
          } else {
            this.$message.error(data.msg);
          }
        });
        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        return false;
      },
      //-- 选择退保人员列表
      chooseList() {
        this.chooseListVisible = true;
      },
      //-- 根据退保人员姓名 - 查询
      queryUserName() {
        if (this.$$.isValidObj(this.selectUserName)){
          this.insuredUserInfoNewList = [];
          for (let i in this.insuredUserInfoList){
            const {name} = this.insuredUserInfoList[i];
            if (name.indexOf(this.selectUserName) >= 0){
              this.insuredUserInfoNewList.push(this.insuredUserInfoList[i]);
            }
          }

          if (this.insuredUserInfoNewList.length == 0) this.insuredUserInfoNewList = this.insuredUserInfoList;
        } else {
          this.insuredUserInfoNewList = this.insuredUserInfoList;
        }
      },
      //-- 关闭选择退保人员弹窗
      closeChoosePopup(event) {
        let el = event.target;
        if (el.className.toString().indexOf('chooseListPopup') >= 0){
          this.chooseListVisible = false;
        }
      },
      //-- 添加退保人员
      chooseAdd(data) {
        const {name, sex, cardNum, skuId, occId, occName} = data;

        this.addBeInsureData = {       //-- 单个被保人
          id: null,                     // 被保人id
          addBeInsureName: name,      // 被保人姓名
          addBeSex: sex == '男' ? 'M' : sex == '女' ? 'F' : 'O',  // 被保人性别
          addBeInsureIdCard: cardNum, // 被保人证件号
          addBeInsureIdType: 1,       // 被保人证件类型
          bePlan: '',                 // 被保人对应计划
          skuId : skuId,              // 被保人skuId
          occupationId : occId,       // 被保人职业Id
          occupationName: occName,    // 被保人职业名称
        };

        this.addDialogVisibleState = 1;
        this.addAPersonConfirm();
      },
      // -- 数据校验
      dataIsValid() {
        let reg = /^\d+$/;
        let idTypeSixReg = /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/; // 统一社会信用代码正则校验
        let idTypeElevenRge = /[0-9A-HJ-NPQRTUWXY]{9}/; // 组织机构代码正则校验
        let PHONE_REGEX = /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/;  // 手机号正则校验
        let EMAIL_REGEX = /^([a-zA-Z0-9_\.\-])+[\@,\＠](([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;  // 邮箱正则校验
        let TELEPHONE_REGEX = /^\d{3}-\d{8}|\d{4}-\d{7}$/; // 固定电话校验
        let BANK_NUM_REG = /^[0-9]{1,20}$/; // 银行账户校验

        if (!this.$$.isValidObj(this.correctingDate)){
          this.$message.error("请选择批改生效日期~");
          return false;
        }

        if (!this.$$.isValidObj(this.endorInsuredAddList) && !this.$$.isValidObj(this.endorInsuredSubtractList)) {
          this.$message.error("请选择最少一名增员或减员的被保人员!");
          return false;
        }

        if (this.$$.isValidObj(this.endorInsuredAddList)){
          for (let i in this.endorInsuredAddList){
            const {skuId, name} = this.endorInsuredAddList[i];
            if (!this.$$.isValidObj(skuId)){
              this.$message.error(`${name}未设置投保方案!`);
              return false;
            }
          }
        }

        if (this.totalPremium < 0){
          if (!this.$$.isValidObj(this.bankAccount)){
            this.$message.error("请输入收款账户!");
            return false;
          }
          if (!this.$$.bankCardVerification(this.bankAccount)) {
            this.$message.error("收款账户输入有误,请重新输入!");
            return false;
          }
        }

        if (this.needInvoices) {
          if (this.idType !== 6 && !this.$$.isValidObj(this.orderMailInvoiceInfo.tIN)) {
            this.$message.error("请输入发票纳税人识别号!");
            return false;
          }
          if (this.idType !== 6 && !idTypeSixReg.test(this.orderMailInvoiceInfo.tIN)) {
            this.$message.error("纳税人识别号错误,请重新输入!");
            return false;
          }
          if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rName)) {
            this.$message.error("请输入收件人姓名!");
            return false;
          }
          if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rPhone)) {
            this.$message.error("请输入收件人手机号!");
            return false;
          }
          if (PHONE_REGEX.test(this.orderMailInvoiceInfo.rPhone) === false) {
            this.$message.error("收件人手机号错误,请重新输入!");
            return false;
          }
          // 2：电子发票 1：纸质发票
          if (this.receiptType == 2) {
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rMail)) {
              this.$message.error("请输入收件人邮箱!");
              return false;
            }
            if (EMAIL_REGEX.test(this.orderMailInvoiceInfo.rMail) === false) {
              this.$message.error("收件人邮箱错误,请重新输入!");
              return false;
            }
          } else {
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRA)) {
              this.$message.error("请输入税务登记地址!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRA)) {
              this.$message.error("请输入税务登记地址!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRT)) {
              this.$message.error("请输入税务登记电话!");
              return false;
            }
            if (TELEPHONE_REGEX.test(this.orderMailInvoiceInfo.tRT) === false) {
              this.$message.error("税务登记电话错误,请重新输入!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.tRT)) {
              this.$message.error("请输入税务登记电话!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.openBank)) {
              this.$message.error("请输入开户银行!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.bankNum)) {
              this.$message.error("请输入银行账户!");
              return false;
            }
            if (!this.$$.bankCardVerification(this.orderMailInvoiceInfo.bankNum)){
              this.$message.error("银行账户错误,请重新输入!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rAreaId)) {
              this.$message.error("请选择收件人地址!");
              return false;
            }
            if (!this.$$.isValidObj(this.orderMailInvoiceInfo.rAddress)) {
              this.$message.error("请输入收件人具体地址!");
              return false;
            }
          }
        }
        return true;
      },
      //-- 订单提交
      submitOrder() {
        if (!this.dataIsValid()) return;

        let params = {};
        if (this.needInvoices) {
          const {tIN, rName, rPhone, rMail, tRA, tRT, openBank, bankNum, rCityId, rProvinceId, rAreaId, rAddress} = this.orderMailInvoiceInfo;
          params = {
            receiptType: this.receiptType,
            tIN, rName, rPhone, rMail, tRA, tRT, openBank, bankNum, rCityId, rProvinceId, rAreaId, rAddress
          };
        }

        params.orderEndorToken = this.orderEndorToken;
        params.changeEffectiveDate = this.$$.dateFormat(this.correctingDate);
        params.needInvoices = this.needInvoices;
        params.bankAccount = this.bankAccount;

        this.axios.post('/management/orderEndorInfoLog/submitOrderEndorInfo', params).then((response) => {
          let data = response.data;
          if (data.success) {
            this.$message.success('提交成功~');

            params.accode = this.accode;
            params.receiptType = this.receiptType,

            sessionStorage.setItem('personnelConfirmationParams', JSON.stringify(params));
            this.$router.push({name: 'personnelConfirmation'});
          } else {
            this.$message.error(data.msg);
          }
        });
      },
    },
    mounted() {
      this.bankTypeLists();
      let params = sessionStorage.getItem('personnelCorrectingParams');
      if (this.$$.isValidObj(params)){
        params = JSON.parse(params);
        this.orderEndorToken = params.orderEndorToken;
        this.accode = params.accode;

        this.correctingInfo();
      }else {
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'correctingHistoryManagement', query:{type : "27"}});
        });
      }
    }
  }
</script>

<style scoped>
  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }
  .box-card-div-title>.header {
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }
  .box-card-div-title.userInfo {
    width: 96px;
  }
  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 20px;
    display: inline-block;
    position: relative;
  }

  .form-item-label,
  .el-form-item{
    font-size: 1rem;
    font-weight: 500;
    color: #333333;
    margin: 0 auto 10px;
  }

  .form-item-label .rightUnit {
    width: 280px;
    padding: 0 10px;
    display: inline-block;
    background: #F7F7F7;
  }

  /deep/ .el-form-item__content{
    padding-left: 10px;
  }

  .warmPrompt{
    padding-left: 20px;
    font-size: 1rem;
    font-weight: 400;
    color: #FF7052;
    display: inline-block;
  }

  .my-el-table {
    width: 900px;
  }

  .addPersonnel /deep/ .el-form-item__content /deep/ .el-button--default{
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background: #FF7052;
    border-radius: 10px;
    padding: 0 20px;
    margin: 0 10px 15px 0;
    display: inline-block;
  }

  .el-table /deep/ th{
    background: #EBEBEB!important;
    border-bottom: 1px solid #CCCCCC!important;
    border-right: 1px solid #CCCCCC!important;
  }

  /deep/ .el-table--border,
  /deep/ .el-table--group {
    border: 1px solid #CCCCCC!important;
  }

  /*.el-table /deep/ .cell{
    display: block;
  }*/

  .ErrorReminder{
    max-width: 800px;
    background: #F7F7F7;
    font-size: 1rem;
    line-height: 24px;
    padding: 20px;
    margin-bottom: 40px;
  }

  .form-item-label.title{
    color: #333333;
    font-weight: bold;
    font-size: 1.25rem;
  }

  .my-button {
    margin-right: 30px;
    background-color: #F7F7F7;
  }

  .my-button /deep/ .el-radio-button__inner {
    box-shadow: 0 0 0 0 !important;
    -webkit-box-shadow: 0 0 0 0 !important;
    border: 0;
    border-radius: 0 !important;
    background-color: #F7F7F7;
    color: #333333;
  }
  .is-active /deep/ .el-radio-button__inner {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    background-color: #FFEEEB !important;
    color: #FF7052 !important;
    border: 1px solid #FF7052 !important;
  }

  .el-radio-button:first-child /deep/ .el-radio-button__inner {
    border-left: 0;
  }

  .my-input-left /deep/ .el-input__inner {
    max-width: 640px;
  }

  .my-input-left.form-item-input {
    width: calc(100% - 25px);
  }

  .addAPersonPopup,
  .chooseListPopup{
    width: 100%;
    height: 100%;
    padding: 64px 20%;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
  }

  .addAPersonPopup .box-card,
  .addAPersonPopup /deep/ .el-card__body,
  .addAPersonPopup /deep/ .el-form {
    width: 100%;
    height: 100%;
  }

  .addAPersonPopup .box-card{
    overflow: auto;
  }

  .addAPerson-Right-input /deep/ .el-input__inner {
    max-width: 320px;
    padding-right: 30px;
    text-align: center!important;
  }

  .addAPerson-Right-input {
    width: 320px!important;
  }

  /deep/ .el-button{
    height: 40px;
    line-height: 40px;
    margin: 0 5px 5px 10px;
    color: #ffffff;
    background: #FF7052;
    border-radius: 10px;
    padding: 0 10px;
  }

  .increasePremium{
    height: 48px;
    line-height: 48px;
    font-size: 20px;
    font-weight: 500;
    color: #FF7052;
    text-align: center;
    margin-top: 20px;
  }

  .addAPerson-button{
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .addAPerson-button /deep/ .el-button{
    width: 160px;
    height: 40px;
    line-height: 40px;
    margin: 40px 20px;
  }
  .addAPerson-button /deep/ .el-button:first-child{
    background: #F7F7F7;
    color: #CCCCCC;
  }

  /deep/ .el-input__inner {
    max-width: 280px;
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  .form-item-label-big /deep/ .el-form-item__label{
    font-size: 1.25rem !important;
    font-weight: bold;
  }

  .form-item-label /deep/ .el-form-item__label{
    font-size: 1rem!important;
    margin: 0 auto;
  }

  .form-item-label-big /deep/ .el-form-item__label {
    font-size: 20px !important;
  }

  .submitOrder{
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .header-button-order-add {
    width: 20rem;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
  }

  .header-button-order-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  .form-item-input {
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 0px;
    text-align: center;
  }

  /deep/ .cell{
    text-align: center;
  }

  /deep/ .el-form-item__content{
    padding-left: 20px;
  }

  /deep/ .el-tag{
    margin-right: 10px;
  }

  .chooseListPopup{
    padding: 10% 20%;
  }

  .chooseListPopup /deep/ .el-card__body{
    padding: 0;
  }
  .chooseListPopup .title{
    font-size: 16px;
    font-weight: bold;
    color: #ffffff;
    background: #ff7052;
    padding: 0 20px 0 10px;
    line-height: 40px;
  }

  .chooseListPopup .query{
    padding: 20px 30px;
  }

  .chooseListPopup .query input{
    line-height: 25px;
    border: 1px solid #CCCCCC;
    margin-right: 20px;
    padding: 0 5px;
  }
  .chooseListPopup .query button{
    padding: 0 10px;
    background: #ff7052;
    color: #ffffff;
    border: none;
    border-radius: 6px;
  }

  .chooseListPopup /deep/ .el-table__body-wrapper{
    height: 424px;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/preservation/personnelCorrecting.vue